import { createAsyncThunk } from '@reduxjs/toolkit';

import { AdminService } from '../../services';

export const fetchTag = createAsyncThunk('adminSlice/fetchTag', async (id, { rejectWithValue }) => {
  try {
    const { data } = await AdminService.fetchTag(id);

    return data;
  } catch (error) {
    return rejectWithValue(error.response?.data || 'Failed to fetch tag');
  }
});
